const configInstance = process.env.CONFIG as unknown as Gallery.Config.Config

export const config = configInstance
export default config
